import { jsx as _jsx } from "react/jsx-runtime";
import { NewsOutletItem } from "@bluframe/mightychroma-mightytool-ui";
const Add = (props) => _jsx(NewsOutletItem, { isAdd: true, ...props });
export default Add;
